var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { fg } from '@lendi-ui/color';
import Field from '@lendi-ui/field';
import { Email, Person, Smartphone, Message } from '@lendi-ui/icon';
import { ml, my } from '@lendi-ui/spacing';
import { Input } from '@lendi-ui/text-input';
import { body } from '@lendi-ui/typography';
import * as React from 'react';
import * as RFF from 'react-final-form';
import styled from 'styled-components';
import getColour from '@lendi-ui/commons/colours';
var PersonIcon = function () { return (React.createElement(BeforeWrapper, null,
    React.createElement(Person, { color: getColour('fill', 'accent'), width: "24px", height: "24px" }))); };
var PhoneIcon = function () { return (React.createElement(BeforeWrapper, null,
    React.createElement(Smartphone, { color: getColour('fill', 'accent'), width: "24px", height: "24px" }),
    " ",
    React.createElement(React.Fragment, null, "+61"))); };
var MessageIcon = function () { return (React.createElement(BeforeWrapper, null,
    React.createElement(Message, { color: getColour('fill', 'accent'), width: "24px", height: "24px" }))); };
var EmailIcon = function () { return (React.createElement(BeforeWrapper, null,
    React.createElement(Email, { color: getColour('fill', 'accent'), width: "24px", height: "24px" }))); };
export var RFFFieldWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .khJtlg {\n    font-family: 'Open Sans';\n  }\n  .sc-TOsTZ,\n  .Heading-lui__sc-37fddq-0 {\n    font-size: 14px;\n  }\n  .indexstyle__Layout-lui__sc-lnm15l-0 {\n    height: 40px;\n  }\n  .Body-lui__sc-1yhxwuv-0 {\n    font-size: 10px;\n  }\n  .indexstyle__InputWrapper-lui__sc-lnm15l-1 {\n    font-family: 'Open Sans';\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n  }\n  ", "\n  ", "\n  text-align: center;\n"], ["\n  .khJtlg {\n    font-family: 'Open Sans';\n  }\n  .sc-TOsTZ,\n  .Heading-lui__sc-37fddq-0 {\n    font-size: 14px;\n  }\n  .indexstyle__Layout-lui__sc-lnm15l-0 {\n    height: 40px;\n  }\n  .Body-lui__sc-1yhxwuv-0 {\n    font-size: 10px;\n  }\n  .indexstyle__InputWrapper-lui__sc-lnm15l-1 {\n    font-family: 'Open Sans';\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n  }\n  ", "\n  ", "\n  text-align: center;\n"])), my('sm'), fg('shade.500'));
// @ts-ignore
export var BeforeWrapper = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  white-space: nowrap;\n  ", "\n  ", "\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n"], ["\n  white-space: nowrap;\n  ", "\n  ", "\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n"])), ml('sm'), body({ size: 'lg', color: 'shade.500' }));
export var FirstNameField = function (_a) {
    var labelText = _a.labelText, autoFocus = _a.autoFocus, onInputChange = _a.onInputChange, error = _a.error, resetAuthError = _a.resetAuthError, isDisabled = _a.isDisabled;
    return (React.createElement(RFFFieldWrapper, null,
        React.createElement(RFF.Field, { name: "firstName", type: "text" }, function (_a) {
            var input = _a.input, meta = _a.meta;
            return (React.createElement(Field, __assign({}, meta, { label: labelText, htmlFor: "firstNameInput" }),
                React.createElement(Input
                // to pass the UTs
                , __assign({ 
                    // to pass the UTs
                    crossOrigin: "" }, input, { enterKeyHint: 'enter', type: "text", isFullWidth: true, disabled: isDisabled, placeholder: "Type your first name here", "data-testid": "request-first-name", "aria-label": "first name", size: { mobile: 'sm', tablet: 'md', desktop: 'md' }, autoFocus: autoFocus, before: React.createElement(PersonIcon, null), onChange: function (e) {
                        if (error)
                            resetAuthError();
                        onInputChange(e);
                        input.onChange(e);
                    }, className: "fs-exclude" }))));
        })));
};
export var MobileField = function (_a) {
    var autoFocus = _a.autoFocus, error = _a.error, resetAuthError = _a.resetAuthError, labelText = _a.labelText, onInputChange = _a.onInputChange, isDisabled = _a.isDisabled;
    return (React.createElement(RFFFieldWrapper, null,
        React.createElement(RFF.Field, { name: "phoneNumber", type: "tel" }, function (_a) {
            var input = _a.input, meta = _a.meta;
            return (React.createElement(Field, __assign({}, meta, { label: labelText, htmlFor: "phoneNumberInput" }),
                React.createElement(Input
                // to pass the UTs
                , __assign({ 
                    // to pass the UTs
                    crossOrigin: "" }, input, { enterKeyHint: 'enter', type: "tel", isFullWidth: true, disabled: isDisabled, "data-testid": "request-code-phone-number", autoComplete: "tel", autoFocus: autoFocus, size: { mobile: 'sm', tablet: 'md', desktop: 'md' }, "aria-label": "phone number", before: React.createElement(PhoneIcon, null), onChange: function (e) {
                        if (error)
                            resetAuthError();
                        onInputChange(e);
                        input.onChange(e);
                    }, className: "fs-exclude" }))));
        })));
};
export var EmailField = function (_a) {
    var error = _a.error, resetAuthError = _a.resetAuthError, label = _a.label, onInputChange = _a.onInputChange, isDisabled = _a.isDisabled;
    return (React.createElement(RFFFieldWrapper, null,
        React.createElement(RFF.Field, { name: "email" }, function (_a) {
            var input = _a.input, meta = _a.meta;
            return (React.createElement(Field, __assign({}, meta, { label: label, htmlFor: "emailInput" }),
                React.createElement(Input
                // to pass the UTs
                , __assign({ 
                    // to pass the UTs
                    crossOrigin: "" }, input, { enterKeyHint: 'enter', placeholder: "Enter your email address", autoComplete: "email", type: "email", "data-testid": "email-field", disabled: isDisabled, size: { mobile: 'sm', tablet: 'md', desktop: 'md' }, isFullWidth: true, before: React.createElement(EmailIcon, null), onChange: function (e) {
                        if (error && resetAuthError)
                            resetAuthError();
                        onInputChange(e);
                        input.onChange(e);
                    }, className: "fs-exclude" }))));
        })));
};
export var VerifyOtpField = function (_a) {
    var autoFocus = _a.autoFocus, error = _a.error, resetAuthError = _a.resetAuthError, label = _a.label, isDisabled = _a.isDisabled, onInputChange = _a.onInputChange;
    return (React.createElement(RFFFieldWrapper, null,
        React.createElement(RFF.Field, { name: "code", type: "tel" }, function (_a) {
            var input = _a.input, meta = _a.meta;
            return (React.createElement(Field, __assign({}, meta, { label: label, htmlFor: "verifyCodeInput" }),
                React.createElement(Input
                // to pass the UTs
                , __assign({ 
                    // to pass the UTs
                    crossOrigin: "", type: "tel", autoFocus: autoFocus, enterKeyHint: 'enter', autoComplete: "one-time-code", size: { mobile: 'sm', tablet: 'md', desktop: 'md' }, isFullWidth: true, disabled: isDisabled, className: "fs-exclude", placeholder: "Enter 6 digit code", before: React.createElement(MessageIcon, null) }, input, { "data-testid": "verify-code-input", onChange: function (e) {
                        if (error && resetAuthError)
                            resetAuthError();
                        onInputChange(e);
                        input.onChange(e);
                    } }))));
        })));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map